export const brandColors = {
  brand: {
    main: "#ff6b00",
    lightMain: "#fff1df",
    lightGrey: "#f8f8fb",
    grey: "#ebebed",
  }
};
